import { isIOS } from "@/lib/platform"

const LOOP_STORAGE_KEY = "timeline-player-loop"
const AUDIO_SCRUB_STORAGE_KEY = "timeline-player-audio-scrub"

/** Глобальный (на браузер) преф кнопки повтора в timeline-плеере. По умолчанию выкл. */
export function readPlayerLoopPref(): boolean {
  if (typeof window === "undefined") return false
  return window.localStorage.getItem(LOOP_STORAGE_KEY) === "1"
}

export function writePlayerLoopPref(enabled: boolean): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(LOOP_STORAGE_KEY, enabled ? "1" : "0")
}

/**
 * Глобальный преф слышимого скраба. По умолчанию вкл на десктопе и выкл на iOS:
 * там декод больших PCM-буферов рискует памятью вкладки Safari.
 */
export function readPlayerAudioScrubPref(): boolean {
  if (typeof window === "undefined") return false
  const stored = window.localStorage.getItem(AUDIO_SCRUB_STORAGE_KEY)
  if (stored != null) return stored === "1"
  return !isIOS()
}

export function writePlayerAudioScrubPref(enabled: boolean): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(AUDIO_SCRUB_STORAGE_KEY, enabled ? "1" : "0")
}
